import Enumerable from "linq";
import Loading from 'quasar/src/plugins/loading/Loading.js';
import { defineComponent, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { GetHanyoParam } from "~/api/Common/Commands";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { MsgBox } from "~/components/MsgBox";
import MyPageTable from "~/components/MyPageTable.vue";
import { auth } from "~/core/Auth";
import { Log } from "~/extensions/utils";
import { CookieHelper } from "~/extensions/utils/CookieHelper";
import { HanyoKb, InformationDetailBeforeRouteKbn, InformationTarget, PageID } from "~/extensions/utils/DefineTypes";
import { HanyoHelper } from "~/extensions/utils/HanyoHelper";
import { PagingListHelper } from "~/extensions/utils/PagingHelper";
import { store } from "~/store/admin/InformationStore";
import { commonStore } from "~/store/CommonStore";
const log = Log.create("Information");
// お知らせ区分
const informationKbn = ref();
export default defineComponent({
    components: {
        MyPageTable,
        BreadcrumbList
    },
    name: "InformationList",
    beforeRouteEnter(to, from, next) {
        const fromScreen = from.name;
        const relatedScreens = ["information-edit", "information-detail"];
        if (!relatedScreens.includes(fromScreen)) {
            store.clear();
        }
        next();
    },
    async setup() {
        const router = useRouter();
        const pageName = commonStore.pageName(PageID.adminInformationList);
        const top = PageID.top;
        const infoList = PageID.adminInformationList;
        // 掲載対象プルダウン
        let publishKbnList = ref([]);
        const pagingListHelper = new PagingListHelper({ mode: "store", store }, log);
        // テーブルカラム
        const columns = [
            { name: "weight", label: "重要", align: "center", field: "weight", sortable: true },
            { name: "isResponseRequired", label: "要回答", align: "center", field: "isResponseRequired", sortable: true },
            { name: "startAt", label: "掲載開始日", align: "center", field: "startAt", sortable: true },
            { name: "endAt", label: "掲載終了日", align: "center", field: "endAt", sortable: true },
            { name: "target", label: "掲載対象", align: "left", field: "target", sortable: true },
            { name: "targetName", label: "掲載対象名", align: "left", field: "targetName", sortable: true },
            { name: "subject", label: "タイトル", align: "left", field: "subject", sortable: true, headerStyle: "width: 450px; max-width: 450px" },
            { name: "responseCheckButton", align: "center", field: "responseCheckButton", sortable: false },
            { name: "copyButton", align: "center", field: "copyButton", sortable: false },
            { name: "editButton", align: "center", field: "editButton", sortable: false }
        ];
        // 掲載状況プルダウン
        const publishStatusList = [
            { value: 0, label: "掲載中" },
            { value: 1, label: "公開予定" },
            { value: 2, label: "公開終了" }
        ];
        //ページング処理
        const onRequest = async (requestData) => {
            Loading.show();
            await pagingListHelper.paging(requestData);
            Loading.hide();
        };
        //検索ボタン押下の処理
        const onSearch = async () => {
            Loading.show();
            await pagingListHelper.search();
            Loading.hide();
        };
        // 新規登録ボタン押下時の処理
        const onCreateNew = () => {
            router.push({ name: "information-edit" });
        };
        // 掲載対象の名称取得
        const getTargetName = (targetKbn) => {
            return Enumerable.from(publishKbnList.value).firstOrDefault(x => x.value === targetKbn)?.label ?? "";
        };
        // 回答確認ボタン押下時の処理
        const onResponseCheck = (informationNo) => {
            CookieHelper.set("informationDetailBeforeRoute", InformationDetailBeforeRouteKbn.AdminInformationList.toString());
            router.push({ name: "information-detail", query: { informationNo: informationNo } });
        };
        //編集ボタン押下時の処理
        const onClick = (informationNo) => {
            router.push({ name: "information-edit", query: { informationNo: informationNo } });
        };
        // コピーボタン押下時の処理
        const onCopy = (informationNo) => {
            router.push({ name: "information-edit", query: { informationNo: informationNo, isCopy: "true" } });
        };
        // 閲覧のみ判定。支店社員かつ掲載対象が全契約者の場合は閲覧のみ
        const isCanViewOnly = (targetKbn) => {
            return !auth.userInfo.isHeadquarters && (targetKbn === InformationTarget.All || targetKbn === InformationTarget.Contractor);
        };
        // 初期表示処理
        try {
            let gethanyoParam = [new GetHanyoParam(HanyoKb.TargetType, auth.userInfo.isHeadquarters ? "" : "1")];
            let hanyoList = await HanyoHelper.getHanyoList(gethanyoParam);
            let publishKbn = hanyoList.GetByHanyoKb(HanyoKb.TargetType);
            publishKbnList.value = publishKbn;
            await pagingListHelper.initialize();
        }
        catch (ex) {
            await MsgBox.error(ex.data.errorMessage);
            log.error("find", ex);
        }
        return {
            ...toRefs(store),
            pageName,
            top,
            infoList,
            columns,
            expansionState: ref(false),
            publishStatusList,
            publishKbnList,
            informationKbn,
            onSearch,
            onCreateNew,
            onRequest,
            getTargetName,
            onResponseCheck,
            onClick,
            onCopy,
            isCanViewOnly
        };
    }
});
